<div class="modal-lg" *ngIf="signature$ | async as signature">
    <div class="modal-header">
        <h5 class="modal-title modal-title-new">
            <div class="popup-title-new">
                <div class="align-img"><img [src]="coin.image" alt=""></div>
                <h4>
                    {{ 'modals.proccess.receiving' | translate }}
                </h4>
            </div>						 
            <div class="popup-number-new">
                + {{ amount  | currency: '': '': '.2-' + coin.precision }} {{ coin.desc }}
            </div>
            <div class="block-section ">
                <div class="block-section-icon block-section-icon-new">
                    <ng-container *ngIf="isProccess; else successBlock">
                        <div class="review-icon"></div>
                        <div class="title-block-section-icon processing-color">
                            {{ 'modals.proccess.processing' | translate }}
                        </div>
                    </ng-container>
                </div>
            </div>
        </h5>
        <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="bsModalRef.hide()"
        >
            <span aria-hidden="true">×</span>
        </button>
	</div>
    <div class="modal-body"> 					
        <div class="media-medium pb-4" *ngIf="signature.hash">
            <div class="info-transaction info-transaction-defi">
                <div>
                    <label>
                        {{ 'transactions.source-wallet-address' | translate }}
                    </label>
                    <span class="t-txt">
                        {{ signature.from }}
                    </span>
                </div>
                <div>
                    <label>
                        {{ 'transactions.destination-wallet-address' | translate }}
                    </label>
                    <span class="t-txt">
                        {{ signature.to }}
                    </span>
                </div>
                <div>
                    <label>
                        {{ 'transactions.transaction-hash' | translate }}
                    </label>
                    <a class="link-txt" target="_blank" [href]="trxAddress">
                        {{ signature.hash }}
                    </a>
                </div>
            </div><!-- .info-transaction-defi -->
        </div>	      		
    </div>  <!-- .modal-body  -->			
</div>


<ng-template #successBlock>
    <div class="verified-icon"></div>
    <div class="title-block-section-icon completed-color">
        {{ 'modals.proccess.completed' | translate }}
    </div>
</ng-template>